/* eslint-disable */
import React from 'react';
import {Link} from 'react-router-dom';
import '../css/ServiceBars.css';

const cards = [
  {
    header: 'Metabolic Physics',
    description:
      'The research biodefense specialists require to gain a clear and concise understanding of metabolic physics, in and beyond the twenty-first century.',
    link: '/metabolic',
  },
  {
    header: 'Biophysics',
    description: `Explore the biotechnology industry's latest trends, theories, and happenings in the evolving field of biophysics.`,
    link: '/biophysics',
  },
  {
    header: 'Astrophysics',
    description:
      'Discover the clockwork and causalities of our Universe with modern concepts in local, and deep space astrophysics.',
    link: '/astrophysics',
  },
  {
    header: 'Artificial Physics',
    description:
      'Multi-circa cyber research supporting artificial physics applications, state-of-the-art training and recreation innovations, and next-generation military, and consumer biotechnology development trends.',
    link: '/artificial-intelligence-physics',
  },
];

/**
 * The service bars for the mid section of the website
 * @return {Component} ServiceBars component
 */
export default function ServiceBars() {
  return (
    <div className="bar-root">
      <div className="bar-left-container">
        {[0, 1, 2, 3].map((index, value) => (
          <div className="bar-container" key={index}>
            <div className="bar-container-holder">
              <h1>{cards[value].header}</h1>
              <br />
              <p className="bar-text">{cards[value].description}</p>
            </div>
            <div className="bar-button-container">
              <Link to={`${cards[value].link}`}>
                <button className="bar-button">Read More</button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
